import React from 'react'
import ReactDOM from 'react-dom/client'
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'
import App from './App'
import ErrorPage from 'components/errorPage'
import { Provider, createStore } from 'jotai'
import './index.css'
import 'semantic-ui-css/semantic.min.css'

const myStore = createStore()

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      path="/"
      element={
        <Provider store={myStore}>
          <App />
        </Provider>
      }
      errorElement={<ErrorPage />}
    >
      <Route
        path="/dispatch"
        element={
          <Provider store={myStore}>
            <App />
          </Provider>
        }
      />
    </Route>,
  ),
)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<RouterProvider router={router} />)
